var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { TextLink, ButtonLink } from './index';
import { getFieldValue } from '../../utils/helpers';
import { CTA_TYPE } from '../../constants';
import { isFieldValid } from '../../utils/validation';
export const CTALink = (_a) => {
    var { typeField, isNotTabbable } = _a, props = __rest(_a, ["typeField", "isNotTabbable"]);
    if (!isFieldValid(props.field, 'href') || !isFieldValid(props.textField) || !isFieldValid(typeField)) {
        return null;
    }
    const type = getFieldValue(typeField);
    const TYPE = type.toUpperCase();
    if (TYPE === CTA_TYPE.SECONDARY || TYPE === CTA_TYPE.PRIMARY) {
        return React.createElement(ButtonLink, Object.assign({ isSecondary: TYPE === CTA_TYPE.SECONDARY }, props, { isNotTabbable: isNotTabbable }));
    }
    return React.createElement(TextLink, Object.assign({}, props, { isNotTabbable: isNotTabbable }));
};
